import React, { Component } from 'react';
import { Link } from "react-router-dom";
import { Card, CardHeader, CardBody, CardFooter, Label, FormGroup } from 'reactstrap';
import { Row, Col, PageHeader, Input, Table, Spin, Select, DatePicker, Button, Tag, Icon, Modal } from 'antd';
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';
import 'react-bootstrap-table/dist/react-bootstrap-table-all.min.css';
import { urlapi, token, authInfo, CheckTokenExp } from '../../config';
import StatusReport from '../Dropdown/StatusReport';
import ModalSuccess from '../../components/Ants/Modal/ModalSuccess';
import ModalWarning from '../../components/Ants/Modal/ModalWarning';
import moment from 'moment';
import { changeYear } from '../Tools/ChanheYaer';

class Report extends Component {
    constructor(props) {
        super(props);

        this.RequestReportInfo = this.RequestReportInfo.bind(this);
        this.onChangePage = this.onChangePage.bind(this);
        this.onChangeinput = this.onChangeinput.bind(this);
        this.onChangeSelect = this.onChangeSelect.bind(this);
        this.onChangedate = this.onChangedate.bind(this);
        this.onSearch = this.onSearch.bind(this);
        this.onSelectChange = this.onSelectChange.bind(this);
        this.onDelete = this.onDelete.bind(this);
        this.warningModal = this.warningModal.bind(this);
        this.successModal = this.successModal.bind(this);
        this.modalcountDown = this.modalcountDown.bind(this);
        this.handleDownloadFile = this.handleDownloadFile.bind(this)

        this.state = {
            warningModalVisible: false,
            successModalVisible: false,
            message: "",
            messageSuccess: "",
            loading: false,
            rptName: "",
            rptStatus: "",
            startDate: "",
            endDate: "",
            reportlist: [],
            minpage: 1,
            pagesize: 10,
            current: 1,
            totalpage: 0,
            tableloading: false,

            selectedRowKeys: [],
        }
    }

    componentDidMount() {
        this.RequestReportInfo(1, this.state.pagesize);
    }

    //==== Request ReportInfo ====
    RequestReportInfo(startdata, enddata) {
        if (!CheckTokenExp()) {
            this.setState({ tableloading: true })
            let req = JSON.stringify({
                RPT_NAME: this.state.rptName,
                RPT_STATUS: this.state.rptStatus,
                RPT_START_DATE: this.state.startDate,
                RPT_END_DATE: this.state.endDate,
                RPT_START_DATA: startdata,
                RPT_END_DATA: enddata
            });

            fetch(urlapi + "api/requestReports", {
                method: 'post',
                headers: {
                    "Content-type": "application/json; charset=UTF-8",
                    "Authorization": "Bearer " + token
                },
                body: req
            }).then(
                function (data) {
                    if (data.ok) {
                        data.json().then(
                            function (json) {
                                json = changeYear(json)
                                this.setState({ totalpage: json.totalpage, reportlist: json.data });
                                this.setState({ currentpage: startdata == 1 ? 1 : this.state.currentpage });
                                this.setState({ tableloading: false });
                            }.bind(this)
                        );
                    } else {
                        this.setState({ tableloading: false });
                    }
                }.bind(this)
            ).catch(function () {
                this.setState({ tableloading: false });
                Modal.error({
                    content: 'Error on the internal server',
                });
            }.bind(this));
        } else {
            this.props.history.push("/logout");
        }
    }

    onDelete() {
        if (!CheckTokenExp()) {
            this.setState({ tableloading: true })
            let req = JSON.stringify({
                REPORT: this.state.selectedRows
            });

            fetch(urlapi + "api/deleteReport", {
                method: 'post',
                headers: {
                    "Content-type": "application/json; charset=UTF-8",
                    "Authorization": "Bearer " + token
                },
                body: req
            }).then(
                function (data) {
                    if (data.ok) {
                        this.setState({ tableloading: false });
                        //this.RequestReportInfo(1, this.state.pagesize);
                    } else {
                        this.setState({ tableloading: false });
                    }
                }.bind(this)
            ).catch(function () {
                this.setState({ tableloading: false });
                Modal.error({
                    content: 'Error on the internal server',
                });
            }.bind(this));
        } else {
            this.props.history.push("/logout");
        }
    }

    warningModal(value, message, messageSuccess) {
        this.setState({ warningModalVisible: value, message, messageSuccess });

        let modalcontent = document.querySelectorAll('.ant-modal-contentant-modal-content-hide');
        for (var i = 0; i < modalcontent.length; i++) {
            modalcontent[i].className = "ant-modal-content";
        }
    }

    successModal(value) {
        this.onDelete();
        this.setState({ successModalVisible: value });

        let modalcontent = document.querySelectorAll('.ant-modal-contentant-modal-content-hide');
        for (var i = 0; i < modalcontent.length; i++) {
            modalcontent[i].className = "ant-modal-content";
        }
    }

    modalcountDown() {
        let secondsToGo = 2;
        const timer = setInterval(() => {
        }, 1000);
        setTimeout(() => {
            clearInterval(timer);
            this.setState({ successModalVisible: false, selectedRows: [], selectedRowKeys: [] });
            this.RequestReportInfo(1, this.state.pagesize);
            //window.location = '#/report/';
        }, secondsToGo * 1000);


    }

    onSearch() {
        this.RequestReportInfo(1, this.state.pagesize)
    }

    onChangePage(currentPage, pageSize) {
        var enddata = currentPage * pageSize;
        var startdata = ((currentPage * pageSize) + 1) - pageSize;
        this.setState({ currentpage: currentPage, pagesize: pageSize });

        this.RequestReportInfo(startdata, enddata)
    }

    onChangeinput(e) {
        this.setState({ [e.target.name]: e.target.value });
    }

    onChangeSelect(value, e) {
        this.setState({ [e.props.name]: value });
    }

    onChangedate(date, dateString) {
        this.setState({ startDate: dateString[0], endDate: dateString[1] });
    }

    onSelectChange(selectedRowKeys, selectedRows) {
        this.setState({ selectedRowKeys, selectedRows })
    }

    handleDownloadFile(fileOID, fileName) {
        fetch(`${urlapi}api/file/getfile/${fileOID}`, {
            method: 'get',
            headers: {
                "Content-type": "application/json; charset=UTF-8",
                "Authorization": "Bearer " + token
            }
        }).then(response => response.blob())
            .then(blob => {
                this.setState({ exportloading: false });
                var url = window.URL.createObjectURL(blob);
                var a = document.createElement('a');
                a.href = url;
                a.download = `${fileName}.xlsx`;
                document.body.appendChild(a); // we need to append the element to the dom -> otherwise it will not work in firefox
                a.click();
                a.remove();  //afterwards we remove the element again         
            });
    }

    render() {
        const { message, messageSuccess, warningModalVisible, successModalVisible, loading } = this.state;
        const { Option } = Select;
        const { RangePicker } = DatePicker;
        const dateFormat = 'DD/MM/YYYY';
        const columns = [
            {
                title: 'Report Name',
                dataIndex: 'rpT_NAME',
                key: 'rpT_NAME',
                width: '20%',
            },
            {
                title: 'Account',
                dataIndex: 'rpT_ACC',
                key: 'rpT_ACC',
                width: '15%',
            },
            {
                title: 'Date Range',
                dataIndex: 'rpT_RANGE_DATE',
                key: 'rpT_RANGE_DATE',
                width: '25%',
            },
            {
                title: 'Status',
                dataIndex: 'rpT_STATUS',
                key: 'rpT_STATUS',
                width: '10%',
                render: tags => (
                    <Tag style={{ textAlign: 'center' }}
                        className={
                            tags == "Pending" ? "tag-draft" :
                                tags == "In Progress" ? "tag-inProgres" :
                                    tags == "Complete" ? "tag-complete" :
                                        tags == "Error" ? "tag-reject" : ""
                        }>
                        {tags}
                    </Tag>
                ),
            },
            {
                title: 'Create date',
                dataIndex: 'rpT_CREATE_DATE',
                key: 'rpT_CREATE_DATE',
                width: '15%',
            },
            {
                dataIndex: 'key',
                key: 'key',
                render: (key, item) => (

                    <Row gutter={8}>
                        {item.rpT_STATUS != 'Complete' ?
                            <Col xs={12} sm={12} md={12} lg={12} xl={12}>
                                <i
                                    className="fa fa-cloud-download ants-gray"
                                    style={{ color: '#7b7b7b', cursor: "not-allowed" }}
                                    disabled
                                ></i>
                            </Col> :
                            <Col xs={12} sm={12} md={12} lg={12} xl={12}>
                                <i
                                    className="fa fa-cloud-download ants-gray"
                                    style={{ color: '#7b7b7b', cursor: "pointer" }}
                                    onClick={() => this.handleDownloadFile(item.rpT_FILEOID, item.rpT_NAME)}
                                ></i>

                            </Col>
                        }
                    </Row>
                ),
            },
        ];
        const { selectedRowKeys, selectedRows } = this.state
        const rowSelection = {
            selectedRowKeys,
            selectedRows,
            onChange: (e, r) => this.onSelectChange(e, r),
        }
        const data = this.state.reportlist;

        return (
            <div>
                <PageHeader title="Report">
                    <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                        <Row gutter={[16, 16]}>
                            <Col xs={24} sm={12} md={6} lg={6} xl={6}>
                                <Input placeholder="Report Name" name="rptName"
                                    onChange={this.onChangeinput} value={this.state.rptName} />
                            </Col>
                            <Col xs={24} sm={12} md={6} lg={6} xl={6}>
                                <StatusReport
                                    onchange={(e) =>
                                        this.setState({ rptStatus: e })
                                    }
                                />
                            </Col>
                            <Col xs={24} sm={12} md={8} lg={8} xl={8}>
                                <RangePicker
                                    style={{ width: "100%" }}
                                    format={dateFormat}
                                    suffixIcon={<span className="fa fa-calendar-o" />}
                                    onChange={this.onChangedate}
                                    ranges={{
                                        Today: [moment().startOf('day'), moment().endOf('day')],
                                        'Last 7 days': [moment().subtract(6, 'd'), moment()],
                                        'Last week': [moment().subtract(1, 'weeks').startOf('week'), moment().subtract(1, 'weeks').endOf('week')],
                                        'Last 15 days': [moment().subtract(14, 'd'), moment()],
                                        'Last 30 days': [moment().subtract(29, 'd'), moment()],
                                        'This month': [moment().startOf('month'), moment().endOf('month')]
                                    }}
                                />
                            </Col>
                            <Col xs={24} sm={12} md={4} lg={4} xl={4}>
                                <Button icon="search" style={{ width: '100%' }} onClick={this.onSearch}>
                                    Search
                                </Button>
                            </Col>
                        </Row>
                    </Col>
                </PageHeader>

                <div className="content">
                    <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                        <Card>
                            <CardBody>
                                <Row gutter={[16, 16]}>
                                    <Col xs={12} sm={12} md={12} lg={12} xl={12}>
                                        <Row gutter={16} type="flex" justify="start">
                                            <Col xs={24} sm={12} md={12} lg={12} xl={12}>
                                                <Button key="submit" style={{ marginRight: 8 }}
                                                    disabled={this.state.selectedRowKeys.length > 0 ? false : true}
                                                    onClick={() => this.warningModal(true, "Do you want to delete this report?", "Deleted report successfully.")}
                                                >
                                                    <span className="fa fa-trash-o"></span> &nbsp;&nbsp;
                                                    Delete
                                                </Button>
                                            </Col>
                                        </Row>
                                    </Col>
                                    <Col xs={12} sm={12} md={12} lg={12} xl={12}>
                                        <Row gutter={16} type="flex" justify="end">
                                            <Col xs={24} sm={12} md={12} lg={12} xl={12} style={{ textAlign: 'right' }}>
                                                <Link to={'/report/new'} >
                                                    <Button type="primary" style={{ marginRight: 8 }}>
                                                        <span className="fa fa-plus-circle"></span> &nbsp;&nbsp;
                                                        Create
                                                    </Button>
                                                </Link>
                                            </Col>
                                        </Row>
                                    </Col>
                                </Row>
                                <Row gutter={[16, 16]}>
                                    <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                                        <Spin spinning={this.state.tableloading}>
                                            <FormGroup>
                                                <Table
                                                    rowKey={key => key.RPT_ID}
                                                    pagination={{
                                                        current: this.state.currentpage,
                                                        defaultPageSize: "10",
                                                        pageSizeOptions: ['10', '20', '50'],
                                                        showSizeChanger: true,
                                                        total: this.state.totalpage,
                                                        showTotal: (total, range) => `${range[0]}-${range[1]} of ${this.state.totalpage} items`,
                                                        onShowSizeChange: (currentPage, pageSize) => this.onChangePage(currentPage, pageSize),
                                                        onChange: (currentPage, pageSize) => this.onChangePage(currentPage, pageSize)
                                                    }}
                                                    rowSelection={rowSelection}
                                                    columns={columns}
                                                    dataSource={data}
                                                />
                                            </FormGroup>
                                        </Spin>
                                    </Col>
                                </Row>
                            </CardBody>
                        </Card>
                    </Col>
                </div>

                <ModalWarning loading={loading}
                    warningModalVisible={warningModalVisible}
                    warningModal={this.warningModal}
                    successModal={this.successModal}
                    modalcountDown={this.modalcountDown}
                    message={message}
                    messageSuccess={messageSuccess}
                />

                <ModalSuccess loading={loading}
                    successModalVisible={successModalVisible}
                    successModal={this.successModal}
                    messageSuccess={messageSuccess}
                />
            </div>

        );
    }
}

export default Report;



// WEBPACK FOOTER //
// ./src/views/Report/Report.js